/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  FETCH_SIGNAL_BY_ID_FAILURE,
  FETCH_SIGNAL_BY_ID_REQUEST,
  FETCH_SIGNAL_BY_ID_SUCCESS,
  SELECTED_ALERT_CLEAR,
  SELECTED_ALERT_REQUEST,
} from '../../../constants/ActionTypes';

const details = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_SIGNAL_BY_ID_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_SIGNAL_BY_ID_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_SIGNAL_BY_ID_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const alert = (state = { data: {} }, action) => {
  switch (action.type) {
    case SELECTED_ALERT_REQUEST:
      return { ...state, data: action.data };
    case SELECTED_ALERT_CLEAR:
      return { data: {} };
    default:
      return state;
  }
};

const signalsDetails = combineReducers({
  details,
  alert,
});

export default signalsDetails;
